$(document).ready(function() {
 // ======================= Product add to cart in side cart start ===============================================================

    function addToCartSuccess() {
        $.get( "/cart?view=mini", function( data ) {
            $('#crt').html(data);
            $(".js-cwr-side-cart").addClass('is-active');
            $("body").addClass('is-active-cart'); 
            if($(".js-cwr-related-product-side-cart-slider").length > 0) {
              $('.js-cwr-related-product-side-cart-slider').slick({
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 4L6 8L10 12" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                  lazyLoad: 'progressive'
              });
            }
           
              
        //   $('#crt').removeClass('loading');
        });
      }

      function refreshCart(cart) {
        $('body').find('.cart-count').text(cart.item_count);
      } 

    $('body').on('click','.add-to-cart',function(e){
        e.preventDefault();
        var variant_id = $("#variant-select").find("option:selected").attr("data-variantid");
        var qty = $(this).closest('.cwr-product-details__cta').find("input").val();
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:{
            id:variant_id,
            quantity: qty
        },
        dataType: 'json',
        }).done(function(item) {
            addToCartSuccess();
            $.getJSON('/cart.js', function(cart){
                refreshCart(cart);
              });
            // window.location.href = '/cart';
        });
    });
// ======================= Product add to cart in side cart end ===============================================================


// ======================= Product Remove from sidecart start ===============================================================

    $("body").on("click", "#crt a.cwr-link", function(e){
    e.preventDefault();
    // alert("remove");
    var id = $(this).data("id");
        $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
        id: id,
        quantity:0
        },
        success: function(){
        $.getJSON('/cart.js', function(cart){
            refreshCart(cart);
        });
        addToCartSuccess();
        }
        });
    });

// ======================= Product Remove from sidecart start ===============================================================
$("body").on("click", ".checkout_button_mini", function(e){
    e.preventDefault();
    var checked = $('.minicart_agree').is(':checked');
    var checkMessage = $(this).siblings('.js-terms-cond-check-message');
    if (checked) {
        checkMessage.css('display','none');
        window.location.href = '/checkout';
    } else {
        $('.js-terms-cond-check-message').show();
    }  
    });

    $("body").on("click", ".checkout_button", function(e){
        e.preventDefault();
        var checked = $('.cart_agree').is(':checked');
        var checkMessage = $(this).siblings('.js-terms-cond-check-message');
        if (checked) {
            checkMessage.css('display','none');
            window.location.href = '/checkout';
        } else {
            $('.js-terms-cond-check-message').show();
        }  
    });

    $("body").on("click", ".cart_agree", function(e){
        var checked = $(this).is(':checked');
        var checkMessage = $(this).siblings('.js-terms-cond-check-message');
        if (checked) {
            checkMessage.css('display','none');
        } else {
            $('.js-terms-cond-check-message').show();
        }  
    })

    $("body").on("click", ".minicart_agree", function(e){
        var checked = $(this).is(':checked');
        var checkMessage = $(this).siblings('.js-terms-cond-check-message');
        if (checked) {
            checkMessage.css('display','none');
        } else {
            $('.js-terms-cond-check-message').show();
        }  
    })
    

});

